import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import masterService from './masterService';

export const getAllMasterEntryData = createAsyncThunk(
	'/getAllMasterEntryData',
	async (thunkAPI) => {
		try {
			const response = await masterService.getAllMasterEntry();
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);
const initialState = {
	AllMasterEntry: [],
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const dropdownSlice = createSlice({
	name: 'dropdowns',
	initialState,
	reducers: {
		reset: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
		resetMessage: (state) => {
			state.message = '';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllMasterEntryData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllMasterEntryData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.AllMasterEntry = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getAllMasterEntryData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			});
	},
});

export const { reset, resetMessage } = dropdownSlice.actions;
export default dropdownSlice.reducer;
